import {
  getDiscountCodeFromUrl,
  saveDiscountCodeToCookie,
  isValidDiscountCode,
} from '@/utils';
import { useConfig } from '@travelwin/core';
import { useState, useEffect } from 'react';
import DiscountPopup from './DiscountPopup';

export const DiscountCodeManager = () => {
  const codeFromUrl = getDiscountCodeFromUrl();
  const { PROMO_VOUCHER_POPUP_ENABLED } = useConfig();
  const isValid = isValidDiscountCode(codeFromUrl);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (codeFromUrl) saveDiscountCodeToCookie(codeFromUrl);
  }, []);

  useEffect(() => {
    if (PROMO_VOUCHER_POPUP_ENABLED && isValid) {
      setShowModal(true);
    }
  }, [PROMO_VOUCHER_POPUP_ENABLED, isValid]);

  if (!showModal) return null;

  return (
    <DiscountPopup
      discountCode={codeFromUrl}
      showModal={showModal}
      onClose={() => setShowModal(false)}
    />
  );
};
